import { observable, decorate, action } from 'mobx'
import cognitoUser from '../cognito-objects/cognitoUser'

class ConfirmUserStore {
  constructor (rootStore) {
    this.user = {
      email: '',
      confirmationCode: '',
      isFetching: false,
      isDone: false
    }
    this.rootStore = rootStore.stores
  }

  handleChange (value, name) {
    this.user[name] = value
  }

  setEmail (email) {
    this.user.email = email
  }

  confirmUser (event) {
    event.preventDefault()
    this.user.isFetching = true
    const user = cognitoUser(this.user.email)
    const confirmUserObj = this
    user.confirmRegistration(this.user.confirmationCode, true, function (error, result) {
      if (error) {
        confirmUserObj.rootStore.notificationStore.sendErrorNotification('Erro!', error.message)
      } else {
        confirmUserObj.rootStore.notificationStore.sendSuccessNotification('Pronto!', 'Usuário confirmado com sucesso')
        confirmUserObj.user.isDone = true
      }
      confirmUserObj.user.isFetching = false
    })
  }
}

decorate(ConfirmUserStore, {
  user: observable,
  handleChange: action,
  confirmUser: action,
  setEmail: action
})

export default ConfirmUserStore



// WEBPACK FOOTER //
// ./src/stores/confirmUserStore.js